import {Injectable} from "@angular/core";
import {AuthConfig, NullValidationHandler, OAuthErrorEvent, OAuthService} from "angular-oauth2-oidc";
import {Router} from "@angular/router";
import {BehaviorSubject, firstValueFrom} from "rxjs";
import {environment} from "../../../environments/environment.local";
import {NgxPermissionsService} from 'ngx-permissions';
import {HttpClient} from "@angular/common/http";

export interface ConnectedUser {
  name: string;
  given_name: string;
  mail: string;
  idAdb2c: string;
  mobilePhone: string;
}

@Injectable({
  providedIn: "root",
})
export class InitialAuthService {
  connectedUser$: BehaviorSubject<ConnectedUser | undefined> = new BehaviorSubject<ConnectedUser | undefined>(undefined);
  currentUser$: BehaviorSubject<any | undefined> = new BehaviorSubject<any | undefined>(undefined);

  private apiUrl = `${environment.apiUrl}/adb2c`;

  constructor(
    private oauthService: OAuthService,
    private authConfig: AuthConfig,
    public router: Router,
    private permissionsService: NgxPermissionsService,
    private http: HttpClient
  ) {
  }

  async initAuth(): Promise<any> {
    return new Promise<void>((resolveFn, rejectFn) => {
      this.oauthService.configure(this.authConfig);
      this.oauthService.tokenValidationHandler = new NullValidationHandler();
      this.oauthService.loadDiscoveryDocument(environment.discoveryUrl);
      //this.oauthService.setupAutomaticSilentRefresh();

      this.oauthService.tryLogin().then(async (isLoggedIn: any) => {

          if (this.isAuthenticated()) {
            const claims: Record<string, any> = this.oauthService.getIdentityClaims();
            console.log(claims);
            let user = await firstValueFrom(this.http.get<any>(`${this.apiUrl}/${claims['sub']}`));

            this.connectedUser$.next({
              name: claims['family_name'],
              given_name: claims['given_name'],
              mail: claims['extension_user_email'] ? claims['extension_user_email'] : user.data.mail,
              idAdb2c: claims['oid'],
              mobilePhone: user.data.mobilePhone
            });

            console.log("user", this.connectedUser$.getValue());

            const userPermissions = claims['role'] ? [claims['role']] : [];
            console.log("userPermissions", userPermissions);
            //const userPermissions = ['ADMIN'];
            this.permissionsService.loadPermissions(userPermissions);
            resolveFn();
          } else {
            this.oauthService.initCodeFlow();
            rejectFn();
          }
        },
        (error) => {
          console.log({error});
          if (error.status === 400) {
            location.reload();
          }
        }).catch((error: OAuthErrorEvent) => {
        console.error(error)
      });

    });
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken();
  }

  logoutSession() {
    this.oauthService.logOut();
  }
}
